import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import type { AdminSearchResults } from '../lib/types'

export function AdminGlobalSearch() {
  const [q, setQ] = useState('')
  const [results, setResults] = useState<AdminSearchResults | null>(null)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  async function runSearch(value: string) {
    setQ(value)
    if (value.trim().length < 2) {
      setResults(null)
      setOpen(false)
      return
    }
    const data: AdminSearchResults = await api(`/admin/search?q=${encodeURIComponent(value.trim())}`)
    setResults(data)
    setOpen(true)
  }

  function goTo(path: string) {
    setOpen(false)
    setQ('')
    navigate(path)
  }

  const hasResults = results && (results.organizations.length + results.providers.length + results.patients.length) > 0

  return (
    <div className="admin-search" style={{ position: 'relative' }}>
      <input
        className="inp"
        style={{ width: 260 }}
        placeholder="Search organizations, providers, patients…"
        value={q}
        onChange={(e) => runSearch(e.target.value)}
        onFocus={() => q.trim().length >= 2 && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {open && results && (
        <div className="card" style={{ position: 'absolute', top: '110%', right: 0, width: 320, zIndex: 20, maxHeight: 360, overflowY: 'auto' }}>
          {!hasResults && <div className="muted" style={{ padding: 8, fontSize: 13 }}>No matches.</div>}
          {results.organizations.length > 0 && (
            <div>
              <div className="sh-note" style={{ padding: '4px 8px' }}>Organizations</div>
              {results.organizations.map((o) => (
                <div key={o.id} className="row" style={{ cursor: 'pointer', padding: '6px 8px' }} onMouseDown={() => goTo(`/admin/organizations/${o.id}`)}>
                  <span>{o.name}</span><span className="muted">{o.type || '—'}</span>
                </div>
              ))}
            </div>
          )}
          {results.providers.length > 0 && (
            <div>
              <div className="sh-note" style={{ padding: '4px 8px' }}>Providers</div>
              {results.providers.map((p) => (
                <div key={p.id} className="row" style={{ cursor: 'pointer', padding: '6px 8px' }} onMouseDown={() => goTo('/admin/providers')}>
                  <span>{p.name}</span>
                </div>
              ))}
            </div>
          )}
          {results.patients.length > 0 && (
            <div>
              <div className="sh-note" style={{ padding: '4px 8px' }}>Patients</div>
              {results.patients.map((p) => (
                <div key={p.id} className="row" style={{ cursor: 'pointer', padding: '6px 8px' }} onMouseDown={() => goTo('/admin/patients')}>
                  <span>{p.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
